/**
 * OA Collection Grid — Filter panel (prijs, type, vendor, beschikbaarheid, sorteren)
 * Door Online Actief (online-actief.nl)
 */
(() => {
  function initFilters() {
    /* Verwijder weeskinderen: panel/overlay zonder bijbehorende container (theme-editor reload) */
    document.querySelectorAll('.oa-cg__panel[data-oa-cg-panel-owner], .oa-cg__panel-overlay[data-oa-cg-panel-owner]').forEach(node => {
      const ownerId = node.getAttribute('data-oa-cg-panel-owner');
      if (!document.querySelector('[data-oa-cg][data-oa-cg-id="' + ownerId + '"]')) node.remove();
    });

    document.querySelectorAll('[data-oa-cg]').forEach(container => {
      if (container._oaCGFilters) return;
      container._oaCGFilters = true;
      if (!container.getAttribute('data-oa-cg-id')) {
        container.setAttribute('data-oa-cg-id', 'cg-' + Math.random().toString(36).slice(2, 9));
      }
      const ownerId = container.getAttribute('data-oa-cg-id');

      /* Cleanup vorige instances binnen deze container (bv. theme-editor reload of
         dubbele script-injectie) zodat we niet eindigen met 2 size-tab rijen of
         2 filter knoppen die elkaar tegenwerken. */
      container.querySelectorAll('[data-oa-cg-size-tabs]').forEach(n => n.remove());
      const _panelWrap = container.querySelector('[data-oa-cg-filter-panel]');
      if (_panelWrap) _panelWrap.innerHTML = '';

      /* i18n strings: globaal uit #oa-modules-i18n (App Embed → Translate & Adapt) */
      let i18n = {};
      const i18nScript = document.getElementById('oa-modules-i18n') || container.querySelector('[data-oa-cg-i18n]');
      if (i18nScript) {
        try { i18n = JSON.parse(i18nScript.textContent || '{}'); } catch (e) {}
      }
      const T = (key, fallback) => i18n[key] || fallback;

      const panelWrap = container.querySelector('[data-oa-cg-filter-panel]');
      if (!panelWrap) return;

      const allCards = Array.from(container.querySelectorAll('.oa-cg__card[data-price]'));
      if (!allCards.length) return;

      /* Gather data — raw waarden (zoals de oude werkende versie) */
      const prices = [];
      const types = new Set();
      const vendors = new Set();
      const sizes = new Set();
      let hasSale = false;
      const now = Math.floor(Date.now() / 1000);

      allCards.forEach(card => {
        prices.push(parseInt(card.dataset.price, 10) || 0);
        if (card.dataset.type) types.add(card.dataset.type);
        if (card.dataset.vendor) vendors.add(card.dataset.vendor);
        if (card.dataset.sizes) {
          card.dataset.sizes.split(',').forEach(s => {
            const t = s.trim();
            if (t) sizes.add(t);
          });
        }
        if (card.querySelector('.oa-cg__badge--sale')) hasSale = true;
      });

      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      const hasTypes = types.size > 1;
      const hasVendors = vendors.size > 1;
      const hasSizes = sizes.size > 1;
      const hasPriceRange = maxPrice > minPrice;

      if (!hasTypes && !hasPriceRange && !hasVendors && !hasSale && !hasSizes) return;

      const activeFilters = {
        types: new Set(),
        vendors: new Set(),
        sizes: new Set(),
        priceMin: minPrice,
        priceMax: maxPrice,
        onlyAvailable: false,
        onlySale: false,
        sort: 'default'
      };

      let priceEventsEnabled = true;

      /* ── Filter button ── */
      const filterBtn = document.createElement('button');
      filterBtn.type = 'button';
      filterBtn.className = 'oa-cg__panel-btn';
      filterBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg><span>' + T('filters', 'Filters') + '</span>';
      panelWrap.appendChild(filterBtn);

      /* Badge */
      const badge = document.createElement('span');
      badge.className = 'oa-cg__panel-badge';
      filterBtn.appendChild(badge);

      /* Results count */
      const resultsEl = document.createElement('span');
      resultsEl.className = 'oa-cg__panel-results';
      panelWrap.appendChild(resultsEl);

      /* Active filter tags */
      const tagsRow = document.createElement('div');
      tagsRow.className = 'oa-cg__panel-tags';
      panelWrap.appendChild(tagsRow);

      /* ── Overlay + Panel ──
         Mount op <body> zodat position:fixed echt viewport-relatief is.
         Reden: .oa-cg__header heeft data-oa-reveal → transform + will-change,
         dat maakt een containing block waardoor fixed binnen de header gevangen blijft. */
      const overlay = document.createElement('div');
      overlay.className = 'oa-cg__panel-overlay';
      overlay.setAttribute('data-oa-cg-panel-owner', ownerId);
      document.body.appendChild(overlay);

      const panel = document.createElement('div');
      panel.className = 'oa-cg__panel';
      panel.setAttribute('data-oa-cg-panel-owner', ownerId);
      /* Accent-CSS-vars meegeven omdat panel buiten .oa-cg leeft */
      const cs = getComputedStyle(container);
      panel.style.setProperty('--oa-cg-accent', cs.getPropertyValue('--oa-cg-accent') || '#55fffa');
      panel.style.setProperty('--oa-cg-accent-text', cs.getPropertyValue('--oa-cg-accent-text') || '#000');
      panel.style.setProperty('--oa-cg-border', cs.getPropertyValue('--oa-cg-border') || '#e0e0e0');
      panel.style.setProperty('--oa-cg-text', cs.getPropertyValue('--oa-cg-text') || '#1d1d1b');
      document.body.appendChild(panel);

      /* Panel header */
      const panelHead = document.createElement('div');
      panelHead.className = 'oa-cg__panel-head';
      panelHead.innerHTML = '<span class="oa-cg__panel-head-title">' + T('filters', 'Filters') + '</span>';
      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'oa-cg__panel-close';
      closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      panelHead.appendChild(closeBtn);
      panel.appendChild(panelHead);

      /* Panel body */
      const panelBody = document.createElement('div');
      panelBody.className = 'oa-cg__panel-body';
      panel.appendChild(panelBody);

      /* ── Type section ── */
      if (hasTypes) {
        panelBody.appendChild(buildChipSection(T('category', 'Categorie'), types, activeFilters.types, applyFilters, 'data-filter-type'));
      }

      /* ── Vendor section ── */
      if (hasVendors) {
        panelBody.appendChild(buildChipSection(T('brand', 'Merk'), vendors, activeFilters.vendors, applyFilters, 'data-filter-vendor'));
      }

      /* ── Size section: inline pill-row tussen de collectie tabs (single-select, wisselt prijzen) ── */
      /* Sla over als de pagina een vaste maat heeft ingesteld — dan is de filter overbodig */
      const hasFixedSize = !!container.getAttribute('data-oa-cg-fixed-size');
      if (hasSizes && !hasFixedSize) {
        const sizeRow = el('div', 'oa-cg__size-tabs');
        sizeRow.setAttribute('data-oa-cg-size-tabs', '');
        const sortedSizes = Array.from(sizes).sort(sortSizes);
        sortedSizes.forEach(val => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'oa-cg__size-tab';
          chip.setAttribute('data-filter-size', '');
          chip.dataset.filterVal = val;
          chip.textContent = val.toUpperCase();
          chip.addEventListener('click', () => {
            const wasActive = activeFilters.sizes.has(val);
            activeFilters.sizes.clear();
            sizeRow.querySelectorAll('.oa-cg__size-tab').forEach(c => c.classList.remove('is-active'));
            if (!wasActive) {
              activeFilters.sizes.add(val);
              chip.classList.add('is-active');
            }
            applyFilters();
          });
          sizeRow.appendChild(chip);
        });
        const collTabs = container.querySelector('.oa-cg__filters');
        if (collTabs && collTabs.parentNode) collTabs.parentNode.insertBefore(sizeRow, collTabs.nextSibling);
        else container.querySelector('.oa-cg__header').appendChild(sizeRow);
      }

      /* ── Price section ── */
      if (hasPriceRange) {
        const sec = el('div', 'oa-cg__panel-section');
        sec.appendChild(el('div', 'oa-cg__panel-label', T('price', 'Prijs')));

        const sliderWrap = el('div', 'oa-cg__panel-slider-wrap');
        /* Step must divide range evenly so min/max are always valid positions */
        const priceRange = maxPrice - minPrice;
        const idealSteps = 20;
        const rawStep = Math.max(100, Math.round(priceRange / idealSteps));
        const numSteps = Math.max(1, Math.round(priceRange / rawStep));
        const step = Math.floor(priceRange / numSteps) || 100;

        const rangeMin = document.createElement('input');
        rangeMin.type = 'range'; rangeMin.className = 'oa-cg__panel-range oa-cg__panel-range--min';
        rangeMin.min = minPrice; rangeMin.max = maxPrice; rangeMin.value = minPrice;
        rangeMin.step = step;

        const rangeMax = document.createElement('input');
        rangeMax.type = 'range'; rangeMax.className = 'oa-cg__panel-range oa-cg__panel-range--max';
        rangeMax.min = minPrice; rangeMax.max = maxPrice; rangeMax.value = maxPrice;
        rangeMax.step = step;

        const track = el('div', 'oa-cg__panel-range-track');
        const trackFill = el('div', 'oa-cg__panel-range-fill');
        track.appendChild(trackFill);

        sliderWrap.appendChild(track);
        sliderWrap.appendChild(rangeMin);
        sliderWrap.appendChild(rangeMax);

        const priceLbl = el('div', 'oa-cg__panel-price-lbl');
        function updatePriceUI() {
          let lo = Math.min(parseInt(rangeMin.value), parseInt(rangeMax.value));
          let hi = Math.max(parseInt(rangeMin.value), parseInt(rangeMax.value));
          /* Clamp to exact bounds so step rounding never creates phantom filter */
          if (lo <= minPrice + step) lo = minPrice;
          if (hi >= maxPrice - step) hi = maxPrice;
          activeFilters.priceMin = lo;
          activeFilters.priceMax = hi;
          priceLbl.textContent = fmt(lo) + '  —  ' + fmt(hi);
          const pct = v => ((v - minPrice) / priceRange) * 100;
          trackFill.style.left = pct(lo) + '%';
          trackFill.style.right = (100 - pct(hi)) + '%';
        }
        rangeMin.addEventListener('input', () => { updatePriceUI(); if (priceEventsEnabled) applyFilters(); });
        rangeMax.addEventListener('input', () => { updatePriceUI(); if (priceEventsEnabled) applyFilters(); });
        updatePriceUI();
        /* Force exact defaults after init */
        activeFilters.priceMin = minPrice;
        activeFilters.priceMax = maxPrice;

        sec.appendChild(sliderWrap);
        sec.appendChild(priceLbl);
        panelBody.appendChild(sec);
      }

      /* ── Toggle filters: Beschikbaar / Sale ── */
      const toggleSec = el('div', 'oa-cg__panel-section');
      toggleSec.appendChild(el('div', 'oa-cg__panel-label', T('other', 'Overige')));
      const toggleChips = el('div', 'oa-cg__panel-chips');

      const availChip = buildToggle(T('in_stock', 'Op voorraad'), () => {
        activeFilters.onlyAvailable = !activeFilters.onlyAvailable;
        applyFilters();
        return activeFilters.onlyAvailable;
      });
      toggleChips.appendChild(availChip);

      if (hasSale) {
        const saleChip = buildToggle(T('on_sale', 'Aanbieding'), () => {
          activeFilters.onlySale = !activeFilters.onlySale;
          applyFilters();
          return activeFilters.onlySale;
        });
        toggleChips.appendChild(saleChip);
      }
      toggleSec.appendChild(toggleChips);
      panelBody.appendChild(toggleSec);

      /* ── Sort section ── */
      const sortSec = el('div', 'oa-cg__panel-section');
      sortSec.appendChild(el('div', 'oa-cg__panel-label', T('sort', 'Sorteren')));
      const sortChips = el('div', 'oa-cg__panel-chips');
      const sortOpts = [
        ['default', T('sort_default', 'Standaard')],
        ['price-asc', T('sort_price_asc', 'Prijs laag → hoog')],
        ['price-desc', T('sort_price_desc', 'Prijs hoog → laag')],
        ['name-asc', T('sort_name_asc', 'Naam A → Z')],
        ['name-desc', T('sort_name_desc', 'Naam Z → A')],
        ['newest', T('sort_newest', 'Nieuwste eerst')]
      ];
      sortOpts.forEach(([val, label]) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'oa-cg__panel-chip' + (val === 'default' ? ' is-active' : '');
        chip.textContent = label;
        chip.dataset.sortVal = val;
        chip.addEventListener('click', () => {
          sortChips.querySelectorAll('.oa-cg__panel-chip').forEach(c => c.classList.remove('is-active'));
          chip.classList.add('is-active');
          activeFilters.sort = val;
          applyFilters();
        });
        sortChips.appendChild(chip);
      });
      sortSec.appendChild(sortChips);
      panelBody.appendChild(sortSec);

      /* ── Panel footer ── */
      const panelFoot = el('div', 'oa-cg__panel-foot');
      const resetBtn = document.createElement('button');
      resetBtn.type = 'button';
      resetBtn.className = 'oa-cg__panel-reset';
      resetBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg> ' + T('clear_all', 'Alles wissen');
      resetBtn.addEventListener('click', resetAll);
      panelFoot.appendChild(resetBtn);

      const applyBtn = document.createElement('button');
      applyBtn.type = 'button';
      applyBtn.className = 'oa-cg__panel-apply';
      applyBtn.textContent = T('show_results', 'Toon resultaten');
      applyBtn.addEventListener('click', closePanel);
      panelFoot.appendChild(applyBtn);
      panel.appendChild(panelFoot);

      /* ── Toggle open/close ── */
      function openPanel() {
        panel.classList.add('is-open');
        overlay.classList.add('is-open');
        filterBtn.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function closePanel() {
        panel.classList.remove('is-open');
        overlay.classList.remove('is-open');
        filterBtn.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      filterBtn.addEventListener('click', openPanel);
      closeBtn.addEventListener('click', closePanel);
      overlay.addEventListener('click', closePanel);
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
      });

      /* ── Reset ── */
      function resetAll() {
        activeFilters.types.clear();
        activeFilters.vendors.clear();
        activeFilters.sizes.clear();
        activeFilters.priceMin = minPrice;
        activeFilters.priceMax = maxPrice;
        activeFilters.onlyAvailable = false;
        activeFilters.onlySale = false;
        activeFilters.sort = 'default';
        panelBody.querySelectorAll('.oa-cg__panel-chip').forEach(c => {
          c.classList.remove('is-active');
          if (c.dataset.sortVal === 'default') c.classList.add('is-active');
        });
        panelBody.querySelectorAll('.oa-cg__panel-toggle').forEach(t => t.classList.remove('is-active'));
        const rMin = panelBody.querySelector('.oa-cg__panel-range--min');
        const rMax = panelBody.querySelector('.oa-cg__panel-range--max');
        priceEventsEnabled = false;
        if (rMin) rMin.value = minPrice;
        if (rMax) rMax.value = maxPrice;
        priceEventsEnabled = true;
        const pl = panelBody.querySelector('.oa-cg__panel-price-lbl');
        if (pl) pl.textContent = fmt(minPrice) + '  —  ' + fmt(maxPrice);
        const fill = panelBody.querySelector('.oa-cg__panel-range-fill');
        if (fill) { fill.style.left = '0%'; fill.style.right = '0%'; }
        applyFilters();
      }

      /* ── Apply filters ── */
      function applyFilters() {
        const hasTypeFilter = activeFilters.types.size > 0;
        const hasVendorFilter = activeFilters.vendors.size > 0;
        const hasSizeFilter = activeFilters.sizes.size > 0;
        const hasPriceFilter = activeFilters.priceMin > minPrice + 1 || activeFilters.priceMax < maxPrice - 1;
        const hasAvail = activeFilters.onlyAvailable;
        const hasSaleFilter = activeFilters.onlySale;
        const hasSort = activeFilters.sort !== 'default';

        let count = activeFilters.types.size + activeFilters.vendors.size + activeFilters.sizes.size +
                    (hasPriceFilter ? 1 : 0) + (hasAvail ? 1 : 0) +
                    (hasSaleFilter ? 1 : 0);

        const visibleGrid = container.querySelector('.oa-cg__grid:not([style*="display:none"]):not([style*="display: none"])') ||
                            container.querySelector('.oa-cg__grid');
        if (!visibleGrid) return;

        const cards = Array.from(visibleGrid.querySelectorAll('.oa-cg__card'));
        let visible = 0;

        /* Bepaal of we de prijzen moeten swappen (1 specifieke maat geselecteerd) */
        const singleSize = activeFilters.sizes.size === 1 ? Array.from(activeFilters.sizes)[0] : null;

        cards.forEach(card => {
          /* Prijs voor deze maat opzoeken in size-prices map */
          let cardPrice = parseInt(card.dataset.defaultPrice || card.dataset.price, 10) || 0;
          if (singleSize) {
            const map = parseSizePrices(card.dataset.sizePrices);
            if (map[singleSize] != null) cardPrice = map[singleSize];
          }
          card.dataset.price = cardPrice;
          updateCardPriceUI(card, cardPrice, !!singleSize);
          updateCardImageUI(card, singleSize);

          const tp = card.dataset.type || '';
          const vn = card.dataset.vendor || '';
          const avail = card.dataset.available === 'true';
          const isSale = !!card.querySelector('.oa-cg__badge--sale');
          let show = true;
          if (hasTypeFilter && !activeFilters.types.has(tp)) show = false;
          if (hasVendorFilter && !activeFilters.vendors.has(vn)) show = false;
          if (hasSizeFilter) {
            /* RAW match: chip-val is precies zoals in data-size-prices ("xl", "xxl", "2 pers.").
               Product moet die maat als variant hebben anders verbergen. */
            const priceKeys = Object.keys(parseSizePrices(card.dataset.sizePrices || ''));
            const hasMatch = Array.from(activeFilters.sizes).some(s => priceKeys.indexOf(s) !== -1);
            if (!hasMatch) show = false;
          }
          /* Price-filter alleen actief als user 'm echt heeft versleept.
             Anders sloopt 't size-filter: swap naar 2-pers (€49,95) > maxPrice (€39,95 default) → ongewenste hide. */
          if (hasPriceFilter && (cardPrice < activeFilters.priceMin || cardPrice > activeFilters.priceMax)) show = false;
          if (hasAvail && !avail) show = false;
          if (hasSaleFilter && !isSale) show = false;
          card.style.display = show ? '' : 'none';
          card._filterVisible = show;
          if (show) visible++;
        });

        /* Sort */
        if (hasSort) {
          const shown = cards.filter(c => c._filterVisible);
          shown.sort((a, b) => {
            switch (activeFilters.sort) {
              case 'price-asc': return (parseInt(a.dataset.price)||0) - (parseInt(b.dataset.price)||0);
              case 'price-desc': return (parseInt(b.dataset.price)||0) - (parseInt(a.dataset.price)||0);
              case 'name-asc': return (a.dataset.title||'').localeCompare(b.dataset.title||'');
              case 'name-desc': return (b.dataset.title||'').localeCompare(a.dataset.title||'');
              case 'newest': return (parseInt(b.dataset.created)||0) - (parseInt(a.dataset.created)||0);
              default: return 0;
            }
          });
          shown.forEach(card => visibleGrid.appendChild(card));
          cards.filter(c => !c._filterVisible).forEach(card => visibleGrid.appendChild(card));
        }

        /* Badge */
        if (count > 0) {
          badge.textContent = count;
          badge.classList.add('is-visible');
        } else {
          badge.textContent = '';
          badge.classList.remove('is-visible');
        }

        /* Results */
        if (count > 0) {
          resultsEl.textContent = visible + ' ' + (visible !== 1 ? T('product_plural', 'producten') : T('product_singular', 'product'));
          resultsEl.classList.add('is-visible');
        } else {
          resultsEl.textContent = '';
          resultsEl.classList.remove('is-visible');
        }

        /* Active tags — rebuild */
        tagsRow.innerHTML = '';
        if (hasTypeFilter) {
          activeFilters.types.forEach(t => addTag(prettyName(t), () => { activeFilters.types.delete(t); syncChips(); applyFilters(); }));
        }
        if (hasVendorFilter) {
          activeFilters.vendors.forEach(v => addTag(prettyName(v), () => { activeFilters.vendors.delete(v); syncChips(); applyFilters(); }));
        }
        if (hasSizeFilter) {
          activeFilters.sizes.forEach(s => addTag(s.toUpperCase(), () => { activeFilters.sizes.delete(s); syncChips(); applyFilters(); }));
        }
        if (hasPriceFilter) {
          addTag(fmt(activeFilters.priceMin) + ' — ' + fmt(activeFilters.priceMax), () => {
            activeFilters.priceMin = minPrice;
            activeFilters.priceMax = maxPrice;
            const rMin = panelBody.querySelector('.oa-cg__panel-range--min');
            const rMax = panelBody.querySelector('.oa-cg__panel-range--max');
            priceEventsEnabled = false;
            if (rMin) rMin.value = minPrice;
            if (rMax) rMax.value = maxPrice;
            priceEventsEnabled = true;
            const pl = panelBody.querySelector('.oa-cg__panel-price-lbl');
            if (pl) pl.textContent = fmt(minPrice) + '  —  ' + fmt(maxPrice);
            const fill = panelBody.querySelector('.oa-cg__panel-range-fill');
            if (fill) { fill.style.left = '0%'; fill.style.right = '0%'; }
            applyFilters();
          });
        }
        if (hasAvail) addTag(T('in_stock', 'Op voorraad'), () => { activeFilters.onlyAvailable = false; syncToggles(); applyFilters(); });
        if (hasSaleFilter) addTag(T('on_sale', 'Aanbieding'), () => { activeFilters.onlySale = false; syncToggles(); applyFilters(); });

        /* Empty message */
        let empty = visibleGrid.querySelector('.oa-cg__empty-msg');
        if (visible === 0 && count > 0) {
          if (!empty) {
            empty = el('div', 'oa-cg__empty-msg', T('no_results', 'Geen producten gevonden met deze filters'));
            visibleGrid.appendChild(empty);
          }
          empty.style.display = '';
        } else if (empty) {
          empty.style.display = 'none';
        }
      }

      function addTag(text, onRemove) {
        const tag = el('button', 'oa-cg__panel-tag');
        tag.type = 'button';
        tag.innerHTML = '<span>' + text + '</span> <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
        tag.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove();
        });
        tagsRow.appendChild(tag);
      }

      function syncChips() {
        panelBody.querySelectorAll('.oa-cg__panel-chip[data-filter-type]').forEach(c => {
          c.classList.toggle('is-active', activeFilters.types.has(c.dataset.filterVal));
        });
        panelBody.querySelectorAll('.oa-cg__panel-chip[data-filter-vendor]').forEach(c => {
          c.classList.toggle('is-active', activeFilters.vendors.has(c.dataset.filterVal));
        });
        container.querySelectorAll('.oa-cg__size-tab[data-filter-size]').forEach(c => {
          c.classList.toggle('is-active', activeFilters.sizes.has(c.dataset.filterVal));
        });
      }
      function syncToggles() {
        panelBody.querySelectorAll('.oa-cg__panel-toggle').forEach(t => {
          if (t.dataset.toggleKey === 'available') t.classList.toggle('is-active', activeFilters.onlyAvailable);
          if (t.dataset.toggleKey === 'sale') t.classList.toggle('is-active', activeFilters.onlySale);
        });
      }

      /* Re-apply on tab change */
      container.querySelectorAll('[data-oa-cg-filter]').forEach(btn => {
        btn.addEventListener('click', () => setTimeout(applyFilters, 50));
      });

      /* Parse "xl=1295|xxl=1495|2 pers.=1995" naar { xl:1295, ... } — RAW keys */
      function parseSizePrices(str) {
        const out = {};
        if (!str) return out;
        str.split('|').forEach(pair => {
          const eq = pair.lastIndexOf('=');
          if (eq < 0) return;
          const k = pair.slice(0, eq).trim();
          const v = parseInt(pair.slice(eq + 1), 10);
          if (k && !isNaN(v)) out[k] = v;
        });
        return out;
      }

      function updateCardPriceUI(card, cents, isSwapped) {
        const priceEl = card.querySelector('.oa-cg__price:not(.oa-cg__price--compare)');
        if (!priceEl) return;
        if (isSwapped) {
          priceEl.textContent = fmt(cents);
        } else {
          const def = card.dataset.defaultPriceFmt;
          if (def) priceEl.textContent = def;
        }
      }

      function parseSizeImages(json) {
        if (!json) return {};
        try { return JSON.parse(json) || {}; } catch (e) { return {}; }
      }

      function updateCardImageUI(card, singleSize) {
        const img = card.querySelector('.oa-cg__card-img');
        if (!img) return;
        if (!card._oaDefaultImg) {
          card._oaDefaultImg = img.getAttribute('src');
          card._oaDefaultSrcset = img.getAttribute('srcset') || '';
        }
        if (singleSize) {
          const map = parseSizeImages(card.dataset.sizeImages);
          if (map[singleSize]) {
            img.setAttribute('src', map[singleSize]);
            if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
            return;
          }
        }
        img.setAttribute('src', card._oaDefaultImg);
        if (card._oaDefaultSrcset) img.setAttribute('srcset', card._oaDefaultSrcset);
      }

      /* ── Helpers ── */
      function el(tag, cls, text) {
        const e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text) e.textContent = text;
        return e;
      }

      function fmt(cents) {
        return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
      }

      function prettyName(handle) {
        return handle.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      }

      function buildChipSection(label, values, activeSet, onChange, attrName, sortFn) {
        const sec = el('div', 'oa-cg__panel-section');
        sec.appendChild(el('div', 'oa-cg__panel-label', label));
        const chips = el('div', 'oa-cg__panel-chips');
        const arr = Array.from(values);
        if (sortFn) arr.sort(sortFn); else arr.sort((a, b) => a.localeCompare(b));
        arr.forEach(val => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'oa-cg__panel-chip';
          chip.textContent = label === 'Maat' ? val.toUpperCase() : prettyName(val);
          chip.setAttribute(attrName, '');
          chip.dataset.filterVal = val;
          chip.addEventListener('click', () => {
            if (activeSet.has(val)) { activeSet.delete(val); chip.classList.remove('is-active'); }
            else { activeSet.add(val); chip.classList.add('is-active'); }
            onChange();
          });
          chips.appendChild(chip);
        });
        sec.appendChild(chips);
        return sec;
      }

      /* Sorteer maten logisch: eerst letter-maten (XS→XXL), dan persoonsmaten oplopend */
      function sortSizes(a, b) {
        const order = ['xxs','xs','s','m','l','xl','xxl','xxxl','3xl','4xl','5xl','1 persoon','2 persoons','3 persoons'];
        const ai = order.indexOf(a.toLowerCase());
        const bi = order.indexOf(b.toLowerCase());
        if (ai !== -1 && bi !== -1) return ai - bi;
        if (ai !== -1) return -1;
        if (bi !== -1) return 1;
        const an = parseFloat(a);
        const bn = parseFloat(b);
        if (!isNaN(an) && !isNaN(bn)) return an - bn;
        return a.localeCompare(b);
      }

      function buildToggle(label, onToggle) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'oa-cg__panel-toggle';
        chip.dataset.toggleKey = label === 'Op voorraad' ? 'available' : 'sale';
        chip.innerHTML = '<span class="oa-cg__panel-toggle-dot"></span>' + label;
        chip.addEventListener('click', () => {
          const active = onToggle();
          chip.classList.toggle('is-active', active);
        });
        return chip;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }
  document.addEventListener('shopify:section:load', initFilters);
})();
